// extracted by mini-css-extract-plugin
export default {"banner":"incident-banner_banner__FTDSI","banner__link":"incident-banner_banner__link__W6XM3"};